import styled from "styled-components";

const SilverImage = styled.img`
  width: 10rem;
  margin: 8rem;
`

export default SilverImage;
